/*
 * InstaMom University — add-ons modal behaviour.
 *
 * Opens snippets/instamom-addons-modal.liquid after a PACKAGE is added to the
 * cart, and on demand from the "Add-ons" button on a package's cart line.
 *
 * Hooks Dawn's pub/sub rather than patching its cart code: product-form.js
 * publishes PUB_SUB_EVENTS.cartUpdate on every successful add, carrying the
 * /cart/add.js response. We compare the added product id against the package
 * ids rendered onto the modal, so adding an ADD-ON never re-opens the modal.
 */
(function () {
  const modal = document.getElementById('InstamomAddons');
  if (!modal) return;

  const packageIds = (modal.dataset.packageIds || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  const open = () => {
    // If the package was added from its preview popup, close that first so the
    // add-ons modal doesn't open stacked behind it.
    document.querySelectorAll('modal-dialog[open]').forEach((other) => {
      if (other !== modal && typeof other.hide === 'function') other.hide();
    });
    // ModalDialog.show() expects an opener to return focus to on close.
    modal.show(document.activeElement || document.body);
  };

  // --- open after a package is added -------------------------------------
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source !== 'product-form') return;
      const added = event.cartData;
      if (!added) return;

      // /cart/add.js returns the line item, or { items: [...] } for multiples.
      const ids = added.items
        ? added.items.map((i) => String(i.product_id))
        : [String(added.product_id)];

      if (ids.some((id) => packageIds.includes(id))) open();
    });
  }

  // --- open from a cart line's "Add-ons" button ---------------------------
  document.addEventListener('click', (event) => {
    if (event.target.closest('.instamom-addons-trigger')) {
      event.preventDefault();
      open();
    }
  });

  // --- add an extra, without leaving the modal ----------------------------
  modal.addEventListener('click', async (event) => {
    const button = event.target.closest('.instamom-addons__add');
    if (!button || button.disabled) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const itemPayload = { id: button.dataset.variantId, quantity: 1 };
      if (button.dataset.addonProperty) {
        itemPayload.properties = { 'Add-on': button.dataset.addonProperty };
      }
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [itemPayload] }),
      });
      if (!res.ok) throw new Error('add failed');

      button.textContent = 'Added ✓';
      refreshCartCount();
    } catch (e) {
      // Leave the shopper somewhere useful rather than failing silently.
      button.textContent = original;
      button.disabled = false;
      console.error('InstaMom add-on add failed', e);
    }
  });

  // --- roommate gift-wrap instruction --------------------------------------
  // Persisted as the cart note (see the snippet's comment for why). Saved on
  // change/blur so it survives the modal closing, and flushed again on skip /
  // "View cart" in case the shopper never blurred the field.
  const noteField = modal.querySelector('[data-roommate-note]');
  const noteSaved = modal.querySelector('[data-roommate-saved]');
  let lastSavedNote = noteField ? noteField.value : null;

  async function saveRoommateNote() {
    if (!noteField) return;
    const value = noteField.value;
    if (value === lastSavedNote) return; // nothing changed — don't spend a request
    lastSavedNote = value;
    try {
      const res = await fetch(`${window.routes.cart_url}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value }),
      });
      if (!res.ok) throw new Error('note update failed');
      if (noteSaved && value.trim()) {
        noteSaved.hidden = false;
        setTimeout(() => { noteSaved.hidden = true; }, 2000);
      }
    } catch (e) {
      // Don't block the shopper on this — but do let the next attempt retry.
      lastSavedNote = null;
      console.error('InstaMom roommate note save failed', e);
    }
  }

  if (noteField) noteField.addEventListener('change', saveRoommateNote);

  // --- the way out ----------------------------------------------------------
  // Off a product page this goes to the CART rather than just closing, so the
  // shopper lands somewhere with a Checkout button instead of back on the box
  // they just added. See the snippet's comment for why it isn't /checkout.
  // Opened from a cart line there's nowhere to go, so it only closes.
  modal.addEventListener('click', async (event) => {
    const skip = event.target.closest('.instamom-addons__skip');
    if (!skip) return;

    // Await the save before navigating — fire-and-forget dies with the page,
    // which is how the roommate note used to get lost on the way to the cart.
    await saveRoommateNote();

    if (skip.hasAttribute('data-close-only')) modal.hide();
    else window.location.href = window.routes.cart_url;
  });

  // Keep the header cart bubble honest after adding from the modal.
  async function refreshCartCount() {
    try {
      const res = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
      const text = await res.text();
      const fresh = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section');
      const current = document.getElementById('cart-icon-bubble');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (e) {
      /* the count will correct itself on the next page load */
    }
  }
})();
